import axios from 'axios';

import { publicAxiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';

export const listWineTypesFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV2RootUrl()}/product/filter/wine-type/for-web?${urlString}`,
    publicAxiosHeaderV2()
  );
};

export const listWineVarietalsFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV2RootUrl()}/product/filter/wine-varietal/for-web?${urlString}`,
    publicAxiosHeaderV2()
  );
};

export const listWineCountryCodesFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV2RootUrl()}/product/filter/wine-country-code/for-web?${urlString}`,
    publicAxiosHeaderV2()
  );
};

export const listWineRegionsFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV2RootUrl()}/product/filter/wine-region/for-web?${urlString}`,
    publicAxiosHeaderV2()
  );
};

export const listWineAppellationsFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV2RootUrl()}/product/filter/wine-appellation/for-web?${urlString}`,
    publicAxiosHeaderV2()
  );
};

export const listVendorsFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV2RootUrl()}/product/filter/vendor/for-web?${urlString}`,
    publicAxiosHeaderV2()
  );
};

export const listWineVintagesFilter = (slug) => {
  const urlString = `collectionSlug=${slug}`;
  return axios.get(
    `${getV2RootUrl()}/product/filter/wine-vintage/for-web?${urlString}`,
    publicAxiosHeaderV2()
  );
};
